import { FunctionalComponent, h } from '@stencil/core';

export interface TitleWithDescriptionProps {
  url?: string;
  title?: string;
  description?: string;
}

export type TitleWithDescriptionTemplateName = 'TitleWithDescription';

export const TitleWithDescription: FunctionalComponent<TitleWithDescriptionProps> = ({ url, title, description }) => {
  return (
    <article>
      <h3 class="adl-h4 adl-space__sm__m-b-none">
        <a href={url}>{title}</a>
      </h3>
      {description && <div class="adl-body" innerHTML={description} />}
    </article>
  );
};
